import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import clsx from 'clsx';
import { Hint } from '@skbkontur/react-ui';
import classes from './TextEllipsis.module.css';
export const TextEllipsis = ({ children, textMaxLines = 1, hintMaxWidth, className, hintContent, hintPosition, }) => {
    const [hasHint, setHasHint] = useState(false);
    const refContainer = useRef(null);
    const handleMouseEnter = () => {
        if (!refContainer.current) {
            return;
        }
        const { offsetHeight, offsetWidth, scrollHeight, scrollWidth } = refContainer.current;
        setHasHint(offsetWidth < scrollWidth || offsetHeight < scrollHeight);
    };
    return (_jsx(Hint, { text: hasHint ? hintContent || children : null, pos: hintPosition || 'bottom center', maxWidth: hintMaxWidth, children: _jsx("div", { ref: refContainer, onMouseEnter: handleMouseEnter, className: clsx(classes.container, className), style: { '--linesCount': textMaxLines }, children: children }) }));
};
